import { DestroyRef, inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, PRIMARY_OUTLET, Router } from '@angular/router';
import { NavService, UserPreferenceStore } from '@ccfx/shared-lib';
import { filter } from 'rxjs';
import { PermissionService } from './permissions.service';

/** Keeps the published shared sidebar from treating query strings as route names. */
@Injectable()
export class BackofficeNavService extends NavService {
  private readonly portalRouter = inject(Router);
  private readonly portalPermissions = inject(PermissionService);
  private readonly preferences = inject(UserPreferenceStore);
  private readonly portalDestroyRef = inject(DestroyRef);
  private initialized = false;

  override initializeOnLoad(): void {
    if (this.initialized) return;
    this.initialized = true;
    this.syncCurrentRoute();
    this.portalRouter.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      takeUntilDestroyed(this.portalDestroyRef),
    ).subscribe(() => this.syncCurrentRoute());
  }

  private syncCurrentRoute(): void {
    const url = this.portalRouter.parseUrl(this.portalRouter.url);
    const route = url.root.children[PRIMARY_OUTLET]?.segments[0]?.path;
    if (!route || ['login', 'no-access', 'not-found'].includes(route)) return;

    if (this.portalPermissions.hasAccess(route)) {
      if (this.portalPermissions.NavcomponentMap.has(route)) {
        this.desiredTabRoute.set(route);
        return;
      }
      if (this.portalRouter.config.some((entry) => entry.path === route && !entry.redirectTo)) {
        return;
      }
    }

    const visible = [...this.portalPermissions.NavcomponentMap.keys()].filter((path) =>
      this.portalPermissions.hasAccess(path),
    );
    const target = [this.desiredTabRoute(), this.preferences.defaultRoute(), ...visible]
      .find((path): path is string => path !== null && visible.includes(path));
    if (target) this.onTabChange(target);
  }
}
